export const resources = [
    {
        category: 'blog',
        id: 0,
    },{
        category: 'video',
        id: 2,
    },{
        category: 'blog',
        id: 1,
    },{
        category: 'article',
        id: 0,
        title: 'Optimistic Rollups for the Rest of Us',
        text:'Optimistic rollups (ORUs) are the most promising avenue for scaling Ethereum - and blockchains in general - today. But what are they, and why are Ethereum developers and scalability researchers so excited about them?',
        image: 'resources/resources-1.png',
        url: 'https://coinmarketcap.com/'
    },{
        category: 'article',
        id: 1,
        title: 'What Is Data Availability?',
        text:'When blockchains begin to scale, they often run into the data availability problem — we break down exactly what that is here.',
        image: 'resources/resources-2.png',
        url: 'https://coinmarketcap.com/'
    },{
        category: 'podcast',
        id: 0,
    },{
        category: 'podcast',
        id: 1,
    },{
        category: 'video',
        id: 5,
    },{
        category: 'whitepaper',
        id: 0,
    },
]
